import { useAirline } from "../context/AirlineContext";
import { TeamFlatGrid } from "../shared/AirlineSlideRenderers";

const SlideRBATeam = () => {
  const { airline } = useAirline();
  return <TeamFlatGrid airline={airline} brand={airline.brandColor || "#FFCD00"} />;
};

export default SlideRBATeam;
